import React, { useState } from "react";
import { useStore } from "./store";
import {
  Home, Map as MapIcon, TrendingUp, Wallet as WalletIcon, User,
  CreditCard, Users, ShoppingBag, BarChart3, Bot, ArrowLeftRight,
  Copy, Check, ScanLine, LogOut, Shield, Bell, ArrowRight, Plus,
  ArrowUpRight, ArrowDownRight, Zap, Gift, Lock, ChevronRight,
  X, Search, MapPin, Star, Circle, Send, Sparkles
} from "lucide-react";

/* ═════════════════════════════════════════════════════════════════
   SHARED COMPONENTS
═════════════════════════════════════════════════════════════════ */
export function Toast() {
  const toast = useStore((s) => s.toast);
  if (!toast) return null;
  return <div className={`toast ${toast.type}`} data-testid="toast">{toast.message}</div>;
}

export function BottomTabs({ active, onChange }) {
  const tabs = [
    { id: "home",    label: "Главная",   Icon: Home },
    { id: "map",     label: "Карта",     Icon: MapIcon },
    { id: "exchange",label: "Биржа",     Icon: BarChart3 },
    { id: "wallet",  label: "Кошелёк",   Icon: WalletIcon },
    { id: "profile", label: "Профиль",   Icon: User },
  ];
  return (
    <nav className="tab-bar">
      {tabs.map((t) => (
        <button
          key={t.id}
          className={`tab-item ${active === t.id ? "active" : ""}`}
          onClick={() => onChange(t.id)}
          data-testid={`tab-${t.id}`}
        >
          <t.Icon />
          <span>{t.label}</span>
        </button>
      ))}
    </nav>
  );
}

export function EnergyBattery({ points = 75, mini = false }) {
  const pct = Math.min(100, Math.max(0, points));
  let color = "#FF4444", mult = "x1.0";
  if (pct >= 75) { color = "#BC13FE"; mult = "x2.0"; }
  else if (pct >= 50) { color = "#00B4FF"; mult = "x1.5"; }
  else if (pct >= 25) { color = "#FFB800"; mult = "x1.2"; }
  if (mini) return (
    <div className="row gap-sm" style={{ fontSize: 11 }}>
      <Zap size={14} color={color} />
      <span style={{ color, fontWeight: 700 }}>{mult}</span>
    </div>
  );
  return (
    <div className="card" data-testid="energy-battery">
      <div className="row between mb-sm">
        <div className="row gap-sm">
          <Zap size={18} color={color} />
          <span className="text-bold">Energy Battery</span>
        </div>
        <span style={{ color, fontWeight: 800 }} className="text-xl">{mult}</span>
      </div>
      <div className="energy-bar" style={{ height: 10 }}>
        <div className="energy-fill" style={{ width: `${pct}%`, background: color }} />
      </div>
      <div className="row between mt-sm" style={{ fontSize: 11 }}>
        <span className="text-hint">{pct} / 100 EP</span>
        <span className="text-hint">Множитель наград</span>
      </div>
    </div>
  );
}
